import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { setupI18n } from '../libs/i18n'
import translations from '../config/translations'
import { loadLocale, saveLocale } from '../services/locale'
import { setUserLocale } from 'services/config/actions'
import { getUser } from 'services/auth/selectors'
import { LOCALES_FROM_API } from 'utils/apiLocales'

const options = Object.keys(translations).map(locale => ({
  value: locale,
  label: locale.toUpperCase(),
}))

const Context = React.createContext({
  locale: loadLocale(),
  options: options,
  changeLocale: () => {},
})

const IntlProviderWrapper = ({ children }) => {
  const dispatch = useDispatch()
  const [locale, setLocale] = useState(loadLocale())
  const user = useSelector(getUser)

  const { messages } = setupI18n(locale)

  const changeLocale = useCallback(
    locale => {
      setLocale(locale)
      saveLocale(locale)
      dispatch(setUserLocale(locale))
    },
    [dispatch],
  )

  useEffect(() => {
    if (user && user.locale) {
      const locale = LOCALES_FROM_API[user.locale]
      setLocale(locale)
      saveLocale(locale)
    }
  }, [user])

  return (
    <Context.Provider value={{ locale: locale, options, changeLocale }}>
      <IntlProvider locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

export { IntlProviderWrapper, Context as IntlContext }
